/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CartDto } from './CartDto';
import {
    CartDtoFromJSON,
    CartDtoFromJSONTyped,
    CartDtoToJSON,
} from './CartDto';
import type { PaymentMethodDto } from './PaymentMethodDto';
import {
    PaymentMethodDtoFromJSON,
    PaymentMethodDtoFromJSONTyped,
    PaymentMethodDtoToJSON,
} from './PaymentMethodDto';
import type { PaymentState } from './PaymentState';
import {
    PaymentStateFromJSON,
    PaymentStateFromJSONTyped,
    PaymentStateToJSON,
} from './PaymentState';

/**
 * 
 * @export
 * @interface ListActivePaymentDto
 */
export interface ListActivePaymentDto {
    /**
     * 
     * @type {CartDto}
     * @memberof ListActivePaymentDto
     */
    cart?: CartDto;
    /**
     * 
     * @type {string}
     * @memberof ListActivePaymentDto
     */
    paymentReference?: string;
    /**
     * 
     * @type {PaymentState}
     * @memberof ListActivePaymentDto
     */
    paymentState: PaymentState;
    /**
     * 
     * @type {PaymentMethodDto}
     * @memberof ListActivePaymentDto
     */
    paymentMethod: PaymentMethodDto;
    /**
     * 
     * @type {string}
     * @memberof ListActivePaymentDto
     */
    deviceId: string;
}

/**
 * Check if a given object implements the ListActivePaymentDto interface.
 */
export function instanceOfListActivePaymentDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "paymentState" in value;
    isInstance = isInstance && "paymentMethod" in value;
    isInstance = isInstance && "deviceId" in value;

    return isInstance;
}

export function ListActivePaymentDtoFromJSON(json: any): ListActivePaymentDto {
    return ListActivePaymentDtoFromJSONTyped(json, false);
}

export function ListActivePaymentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListActivePaymentDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'cart': !exists(json, 'cart') ? undefined : CartDtoFromJSON(json['cart']),
        'paymentReference': !exists(json, 'paymentReference') ? undefined : json['paymentReference'],
        'paymentState': PaymentStateFromJSON(json['paymentState']),
        'paymentMethod': PaymentMethodDtoFromJSON(json['paymentMethod']),
        'deviceId': json['deviceId'],
    };
}

export function ListActivePaymentDtoToJSON(value?: ListActivePaymentDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'cart': CartDtoToJSON(value.cart),
        'paymentReference': value.paymentReference,
        'paymentState': PaymentStateToJSON(value.paymentState),
        'paymentMethod': PaymentMethodDtoToJSON(value.paymentMethod),
        'deviceId': value.deviceId,
    };
}

